<template>
    <div class="global-main">
        <table id="infoTable" class="table">
            <thead>
                <tr>
                    <th></th>
                    <th>Company</th>
                    <th>Wallet</th>
                </tr>
            </thead>
            <tbody v-if="adminDashboardData != null">
                <tr>
                    <td>Finca</td>
                    <td>{{adminDashboardData.finca.company}}</td>
                    <td>{{adminDashboardData.finca.wallet}}</td>
                </tr>
                <tr>
                    <td>Finja</td>
                    <td>{{adminDashboardData.finja.company}}</td>
                    <td>{{adminDashboardData.finja.wallet}}</td>
                </tr>
            </tbody>
        </table>
        <br><br>
        <table id="payrollRunsTable" class="table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Date</th>
                    <th>Active Wallet</th>
                    <th>Payroll Amount</th>
                    <th>Salary Count</th>
                </tr>
            </thead>
            <tbody v-if="adminDashboardData != null">
                <tr v-for="payroll in adminDashboardData.payroll_runs" v-bind:key="payroll.id">
                    <td>{{payroll.companyName}}</td>
                    <td>{{payroll.date}}</td>
                    <td>{{payroll.activeWallet}}</td>
                    <td>{{payroll.payrollAmount}}</td>
                    <td>{{payroll.salaryWallet}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                adminDashboardData : null
            };
        },
        mounted() {
        },
        created() {
            this.$Progress.start();
            // Calling Admin Controller For Dashboard Data
            axios.get('/api/adminDashboardData')
                .then(res => {
                    if(res.status == 200){
                        this.adminDashboardData = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }

                })
                .then(res => {
                     $("#infoTable").dataTable({
                        "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    });
                    $("#payrollRunsTable").dataTable({
                        "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
        }
    }
</script>
